import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { purchasesByProductSearchSchema } from '../../features/reports/operational-search'
import { PurchasesByProductPage } from '../../features/reports/purchases-by-product-page'

export const Route = createFileRoute('/_app/purchases-by-product')({
  staticData: { crumb: 'purchasesByProduct' },
  validateSearch: purchasesByProductSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'purchasing.read'),
  component: PurchasesByProductPage,
})
